enum FormModes {
    Create,
    Edit,
    Disabled,
    Preview,
}

export default FormModes;
